import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './ConsultationPage.css';

export default function ConsultationSuccess() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => navigate('/'), 5000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="consultation-page">
      <div className="consultation-container" style={{ textAlign: 'center', paddingTop: '6rem' }}>
        <div style={{ fontSize: '4rem', marginBottom: '1.5rem' }}>✓</div>
        <h1 className="consultation-title">درخواست شما ثبت شد</h1>
        <p className="consultation-subtitle" style={{ marginBottom: '2rem' }}>
          کارشناسان زوپین به زودی با شما تماس خواهند گرفت.
        </p>
        <button
          className="form-submit"
          style={{ maxWidth: '300px', margin: '0 auto' }}
          onClick={() => navigate('/')}
        >
          بازگشت به صفحه اصلی
        </button>
        <p style={{ marginTop: '1rem', color: '#999', fontSize: '0.85rem' }}>
          بازگشت خودکار پس از ۵ ثانیه...
        </p>
      </div>
    </div>
  );
}
